module.exports = __webpack_public_path__ + "img/家国.4a161a0f.png";